import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useQueryClient } from '@tanstack/react-query';
import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
const revenueOpportunityPreferencesKey = (businessId)=>[
        QueryKeys.PulseOpportunityPreferences,
        businessId
    ];
export const useRevenueOpportunityPreferences = function useRevenueOpportunityPreferences() {
    let { enabled = true, refreshOnHookMount = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _useStore;
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const businessId = (_useStore = useStore(selectors.user.businessId)) !== null && _useStore !== void 0 ? _useStore : null;
    const queryKey = revenueOpportunityPreferencesKey(businessId);
    const { data, isLoading, isFetching, error, refresh, optimisticUpdate } = useQueryState({
        queryKey,
        queryFn: ()=>api.pulse.getPreferences(),
        enabled: enabled && businessId != null,
        refreshOnHookMount
    });
    const reload = ()=>queryClient.invalidateQueries({
            queryKey
        });
    const removeHiddenService = (dismissalId)=>optimisticUpdate((current)=>_object_spread_props(_object_spread({}, current), {
                hiddenServices: current.hiddenServices.filter((service)=>service.dismissalId !== dismissalId)
            }));
    return {
        preferences: data,
        isLoading,
        isFetching,
        error,
        refresh,
        reload,
        removeHiddenService
    };
};
